<template>
    <div :class="[rootClasses]"
            @transitionstart="onTranitionStart"
            @transitionend="onTransitionEnd">
        <div class="lateral-menu--logo grid grid__base">
            <div class="grid--container">
                <div class="grid--row">
                    <div class="grid--col">
                        <app-logo v-bind="home.content"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="lateral-menu--content">
            <div class="lateral-menu--main-menu">
                <main-menu :facets="['vertical']" :children="menuItems"/>
            </div>
            <div class="lateral-menu--languages">
                <language-menu :facets="['lateral-menu']" :children="language.children"/>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import scrollLockMixin from 'framework/mixins/scroll-lock-helper';
    import bemMixin from 'framework/mixins/bem';
    import MainMenu from 'framework/components/main-menu/main-menu';
    import LanguageMenu from '../language-menu/language-menu';
    import AppLogo from '../app-logo/app-logo';

    export default {
        components: {
            AppLogo,
            LanguageMenu,
            MainMenu,
        },
        mixins: [bemMixin('lateral-menu'), scrollLockMixin],
        props: {
            menu: {
                type: Object,
                required: true,
            },
            language: {
                type: Object,
                required: true,
            },
            home: {
                type: Object,
                required: true,
            },
            meta: {
                type: Object,
                required: true,
            },
        },
        computed: {
            ...mapState('lateral-menu', ['isOpen']),
            menuItems() {
                return this.menu.items.concat(this.meta.items);
            },
            rootClasses() {
                return [this.bemRoot, this.bemFacets, this.bemIf(this.isOpen, 'is-open')];
            },
        },
        methods: {
            onTransitionEnd() {
                if (!this.isOpen) {
                    this.onScrollLockAfterLeaveHook();
                }
            },
            onTranitionStart() {
                if (this.isOpen) {
                    this.onScrollLockEnterHook();
                }
            },
        },

    };
</script>
